import React from 'react';
import { Link } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { fmtDate } from '../../../../utils/fmt';

const QuoteListDetails = () => {
  const columns = [
    { label: 'Quote Number', value: 'quote_number' },
    { label: 'Customer', value: (quote) => quote.customer.name },
    { label: 'Status', value: (quote) => quote.status.name },
    {
      label: 'Expiration Date',
      value: (quote) => fmtDate(quote.expiration_date),
    },
    {
      label: 'Line Items',
      value: (quote) => quote.line_items.map(item => item.name).join(', '),
    },
    {
      label: 'Actions',
      value: (quote) => (
        <Link to={`/quotes/edit/${quote.id}`} className="btn btn-primary btn-sm">
          Edit
        </Link>
      ),
    },
  ];

  return (
    <div>
      <h1>Quote List</h1>
      <ListTemplate columns={columns} fetchUrl={`${API_DOMAIN}${API_ROUTES.quote}`} />
    </div>
  );
};

export default QuoteListDetails;
